import React from "react";

import { WSTableColumn, WSText } from "@wingspanhq/fe-component-library";

export const columns: Array<WSTableColumn> = [
  {
    config: {
      header: {
        text: "Name"
      },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: row => (
      <WSText data-testid="resourceFileName" data-testdata={row.data.name}>
        {row.data.name}
      </WSText>
    )
  },
  {
    config: {
      header: {
        text: "Created"
      },
      justify: "end"
    },
    renderFunction: row => (
      <WSText formatDate={"monthDayYear"}>{row.data.createdAt}</WSText>
    )
  }
];
